module.exports = __webpack_public_path__ + "static/media/opera-browser-120.0fa9d8f8.png";


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/assets/img/navegadores/opera-browser-120.png
// module id = 2323
// module chunks = 0